import React from 'react';
import {
  confirmable,
  createConfirmation,
} from 'react-confirm';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

const ConfirmDialog = ({
  show,
  proceed,
  dismiss,
  cancel,
  content,
  options,
}) => {
  const {
    t,
  } = useTranslation(undefined, { useSuspense: false });
  const showConfirmButton = !options?.hideConfirmButton ?? true;

  return (
    <Dialog
      open={show}
      onClose={dismiss}
      fullWidth
      className="confirm-dialog"
    >
      {options?.title && (
        <DialogTitle>
          {options.title}
        </DialogTitle>
      )}
      <DialogContent>
        {content}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => { cancel() }}
          className="confirm-dialog-close-button"
        >
          {t('Close')}
        </Button>
        {showConfirmButton && (
          <Button
            color="primary"
            autoFocus
            onClick={() => { proceed() }}
            className="confirm-dialog-confirm-button"
          >
            {t('Confirm')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

const confirm = createConfirmation(confirmable(ConfirmDialog));

export default function(content, options = {}) {
  return confirm({ content, options });
}
